<div
  class="prohibit-landscape-container"
  [class.prohibit-landscape]="heightIsBelowLimit"
>
  <div class="puzzle-screen-landscape-message">
    <div class="krupion-logo"></div>
    <div class="landscape-message-content" [innerHTML]="'PUZZLE.landscape_notification' | translate"></div>
  </div>
</div>

